import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

import { DataCenterSectionProps } from "@/components/wpl/pricing/src";
import { Card } from "@/libraries/design/components";
type DataCenterPromoCardProps = {
    dataCenterContent: DataCenterSectionProps;
};

export const DataCenterPromoCard = ({
    dataCenterContent
}: DataCenterPromoCardProps) => {
    return (
        <section
            css={css({
                width: "100vw",
                marginBlockStart: token("space.300")
            })}
        >
            <Card
                orientation="horizontal"
                columns={10}
                title={dataCenterContent.title}
                body={dataCenterContent.description}
                callToAction={{
                    text: "Learn more",
                    href: "/enterprise/data-center"
                }}
                // eslint-disable-next-line local/no-non-orangelogic-images-eslint
                spotIllustrationUrl="https://wac-cdn.atlassian.com/misc-assets/webp-images/Illo_DataCenter.svg"
            />
        </section>
    );
};
